<!--
This component is responsible for generating forms based
on provided json configuration
-->
<template>
  <div class="form-generator pt-5">
    <!-- <ProgressBar v-if="current_step_show_progress_bar" :progress="progress">
    </ProgressBar> -->
    <FormDisplay
      v-if="current_step_config"
      :actions="current_actions"
      :add_multiple="current_add_multiple"
      :current_step_id="current_step_id"
      :form_schema="current_form_schema"
      :header="current_header"
      :footer="current_footer"
      :help="current_help"
      :title_page="current_title_page"
      :model="model"
      :autocomplete_list_name="autocomplete_list_name"
      :schema_classes="current_schema_classes"
      @action_next_step="action_next_step"
      @action_previous_step="action_previous_step"
      @action_save="action_save"
      @action_change_route="action_change_route"
      @action_generate_form="action_generate_form"
      @action_autocomplete="action_autocomplete"
    >
    </FormDisplay>
  </div>
</template>
<script>
import Vue from "vue";
// import ProgressBar from "@/components/ProgressBar.vue";
import FormDisplay from "@/components/FormDisplay.vue";
import { set_autocomplete_list } from "../steps/fill_field";
import { Step } from "../steps/step";

export default {
  name: "FormGenerator",
  components: {
    FormDisplay: FormDisplay
    // ProgressBar: ProgressBar
  },
  computed: {
    // return current step actions
    current_actions: function() {
      return this.current_step.actions;
    },
    current_add_multiple: function() {
      return this.current_step.add_multiple;
    },
    // return current step schema
    current_form_schema: function() {
      return this.current_step.form_schema;
    },
    // return current step header
    current_header: function() {
      return this.current_step.header;
    },
    // return current step footer
    current_footer: function() {
      return this.current_step.footer;
    },
    // return current step help
    current_help: function() {
      return this.current_step.help;
    },
    current_schema_classes: function() {
      return this.current_step.schema_classes;
    },
    current_title_page: function() {
      return this.current_step.title_page;
    },
    // return current step object
    current_step: function() {
      var step = new Step(this.current_step_config);
      return step;
    },
    // return if current step allow for showing a progress bar
    current_step_show_progress_bar: function() {
      return this.current_step.show_progress_bar;
    },
    // return model
    model: function() {
      if (this.loaded_model) {
        return this.loaded_model;
      } else {
        return this.config.model;
      }
    },
    autocomplete_list_name: function() {
      return this.async_list_name;
    },
    // return current percentage progress
    progress: function() {
      var total_steps = Object.keys(this.steps).length;
      return Math.round((this.steps_completed.length / total_steps) * 100);
    },
    // return list of steps
    steps: function() {
      return this.config.steps;
    },
    // return current username
    username: function() {
      return this.$store.state.user.display_name;
    }
  },
  data() {
    return {
      // the id of the current step
      current_step_id: null,
      // configuration for current step
      current_step_config: null,
      // global config for full process (all forms and connections between them)
      config: null,
      // number of steps completed
      steps_completed: [],
      // previously saved model,
      loaded_model: null,
      // autocomplete async list from backend response
      async_list_name: []
    };
  },
  methods: {
    // run when route should be changed
    action_change_route: function(route_name) {
      this.$router.push({ name: route_name });
    },
    // run when next_step action happen
    action_next_step: function(step_id) {
      if (!this.steps_completed.includes(this.current_step_id)) {
        this.steps_completed.push(this.current_step_id);
      }
      // save completed steps
      this.$localStorage.set(
        `steps_completed_${this.config.id}`,
        JSON.stringify(this.steps_completed)
      );
      // change step
      this.set_current_step_id(step_id);
    },
    // run when previous action happen
    action_previous_step: function(step_id) {
      this.set_current_step_id(step_id);
    },
    // run when save action happen
    action_save: function(step_id) {
      var $this = this;
      console.log("Action save:", step_id);
      if (!step_id) {
        console.log(
          "No step id defined. Setting up current step:",
          this.current_step_id
        );
        step_id = this.current_step_id;
      }

      Vue.Backend.save_raw_json(
        $this.config,
        $this.model,
        step_id,
        Vue.CognitoAuth.session.id_token,
        this.$store.state.user?.client_data?.pesel
      );
    },
    action_generate_form: function(step_id) {
      var $this = this;
      if (!step_id) {
        console.log(
          "No step id defined. Setting up current step:",
          this.current_step_id
        );
        step_id = this.current_step_id;
      }
      Vue.Backend.generate_form(
        $this.config,
        $this.model,
        step_id,
        Vue.CognitoAuth.session.id_token
      ).then(function(response) {
        // enable button and hide spinner
        const button = document.getElementById("download-button");
        button.disabled = false;
        const download_spinner = document.getElementById("download-spinner");
        download_spinner.style.display = "none";

        // create element in body to download generated form
        var link = document.createElement("a");
        link.href = response.data.filepath;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    action_autocomplete: function(searchQuery, autocomplete_filter) {
      var $this = this;
      Vue.Backend.autocomplete(
        searchQuery,
        autocomplete_filter,
        Vue.CognitoAuth.session.id_token
      ).then(function(response) {
        var resp_list = [];
        response.data.items.forEach(function(item) {
          resp_list.push(item["name"]);
        });
        // list of names
        $this.async_list_name = resp_list;
        // assignment full response list to model for later use in fill_autocomplete
        set_autocomplete_list(response.data.items);
      });
    },
    // load data
    load_data: function(loaded_model, step_id) {
      console.log("Setting up loaded model:", loaded_model);
      this.loaded_model = loaded_model;
      if (step_id) {
        this.set_current_step_id(step_id);
      }
    },

    // load main config file
    load_main_config: function() {
      // Read provided config file
      console.log("Looking for a config file: ", this.config_file);
      this.axios.get(this.config_file).then(response => {
        console.log("Reading config for: ", response.data.name);
        this.config = response.data;

        // reading data for specific step
        this.set_current_step_id(this.config.start_step_id);
      });
    },
    // set config for current step
    set_current_step_config: function() {
      this.axios
        .get(this.config.steps[this.current_step_id].config_file)
        .then(response => {
          console.log("Reading config for: ", response.data.id);
          this.current_step_config = response.data;
          this.validate_current_step();
        });
    },
    // set current step id this should be used when new step going to be loaded
    set_current_step_id: function(step_id) {
      console.log("Setting a step with id: ", step_id);
      this.current_step_id = step_id;
      this.set_current_step_config();
    },
    // validate current step if it's ok to display it based on
    // defined display_conditions. If it's valid step remains as it is
    // if not - a new step is loaded
    validate_current_step: function() {
      var display_conditions = this.config.steps[this.current_step_id]
        .display_conditions;

      // if there is no display conditions, assumed that all is good
      if (display_conditions == null) return;

      // iterate over display conditions
      // if at least one is not met need to preform
      // defined action for it
      var on_fail = null;
      var username = this.username;
      display_conditions.forEach(function(display_condition) {
        // check if user is authenticated or not
        if (display_condition.name == "user_authenticated") {
          if (display_condition.is_authenticated == true) {
            // user has to be authenticated
            if (username == null) {
              on_fail = display_condition.on_fail;
              return;
            }
          } else {
            // user has to be anonymous
            if (username != null) {
              on_fail = display_condition.on_fail;
              return;
            }
          }
        }
      });

      // if there was a fail in checking a step
      // make a defined action
      if (on_fail) {
        if (on_fail.name == "change_route") {
          this.action_change_route("Login");
        }
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.load_main_config();
      if (
        this.$store.state.user.is_proxy &&
        !this.$store.state.user.client_data?.pesel
      ) {
        this.$router.push({ name: "ProxyManage" });
      }
    });
  },
  props: {
    config_file: String,
    authenticated_user: Object
  },
  watch: {
    username(new_username, old_username) {
      // Logout
      console.log(`Username has changed: ${old_username} => ${new_username}`);
      if (new_username == null) {
        // Do we need this?
        this.load_main_config();
      }
    },

    config() {
      console.log("Config changed, checking if there are saved data...");
      var $this = this;
      if (Vue.CognitoAuth.is_authenticated) {
        Vue.CognitoAuth.get_current_user_data().then(function() {
          Vue.Backend.get_raw_json(
            $this.config,
            Vue.CognitoAuth.session.id_token,
            $this.$store.state.user?.client_data?.pesel
          ).then(function(json_data) {
            console.log("Get response from backend:", json_data);
            if (json_data.data.message == "success") {
              $this.load_data(json_data.data.model, json_data.data.step_id);
            } else {
              console.log("Error loading data:", json_data.message);
            }
          });
        });
      } else {
        console.log("No Cognito session. Ending user session");
        $this.$store.dispatch("user_session_ended");
      }
    }
  }
};
</script>

<style>
.errors span {
  padding: 5px;
  font-size: small;
  color: red;
}

div.hint {
  font-size: small;
}
</style>
